export const passwordInput = {
  repitionError: 'Bitte geben Sie das gleiche Passwort ein',
  complexityError: 'Mindestens 8 Zeichen. Ein Gross- und ein Kleinbuchstabe. Eine Nummer.',
}
